import {emptyResult, Facet, Record, Result, SourceType} from '@types';
import axios from 'axios';
import isArray from 'lodash/isArray';
import moment from 'moment';

export const getQuery = (searchString: string, sources?: SourceType[], from?: number, size?: number): string => {
    return JSON.stringify({
        searchString,
        sources,
        from,
        size,
        language: 'en',
        sort: [{_score: 'desc'}]
    });
};

export const postSearch = async (query: string): Promise<Result> => {
    try {
        const {
            data: {
                hits: {
                    hits,
                    total
                },
                aggregations: {
                    facets: {
                        buckets
                    }
                }
            }
        } = await axios.post('/api/search', query, {headers: {'Content-Type': 'application/json'}});
        const records = getRecords(hits);
        const facets = getFacets(buckets);
        return {records, total: total.value, facets};
    } catch (e) {
        console.log(e);
        return emptyResult;
    }
};

const getRecords = (hits: any[]): Record[] => hits
    .map((hit: any): Record => {
        const id = hit._id;
        const {content, updated_at, ...rest} = hit._source;
        const updatedAt = moment(updated_at).format('MM/DD/YYYY');
        return isArray(content)
            ? {...rest, id, text: truncateText(content[0]?.text), url: content[0]?.url, updatedAt}
            : {...rest, id, text: truncateText(content?.text), url: content?.url, updatedAt};
    });

const getFacets = (buckets: any[]): Facet => SourceType.values
    .reduce((o: any, source: SourceType) => {
        const bucket = buckets.find(bucket => bucket.key === source);
        o[source] = !!bucket ? bucket.doc_count : 0;
        return o;
    }, {});

const truncateText = (text: string, length: number = 250) => {
    const safeText = text || '';
    return safeText.length <= length ? safeText : safeText.substring(0, length) + '...';
};
